import React, { useContext, useState, useEffect, useRef } from 'react';
import { store } from './Customer';
// import { store as mainStore } from '../../../../../../store';
// import { DataGrid } from '@material-ui/data-grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { localText } from '../../../../../../langs/fa/data-grid';
import moment from 'moment-jalaali';
import { __ } from '../../../../../../utils/i18n';
import { useHistory, useParams } from 'react-router-dom';
import NoOrders from './NoOrders';
import Accordion from '../../../../../../components/Accordion/Accordion';
import FleetsTextFields from '../../../../../../components/TextFields/FleetsTextFields';
import SelectCities from '../../../../../../components/FormInputs/SelectCities';
import { makeStyles } from '@material-ui/core/styles';
import DataGrid from 'components/DataGrid/DataGrid';
import { useMediaQuery } from '@material-ui/core';
import { useMainStore } from 'useStores/useMainStore';
import { useSearchParams } from 'hooks/useSearchParams';

const useStyles = makeStyles((theme) => ({
  filters: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const OrdersList = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { state, dispatch } = useContext(store);
  const { fetchingOrders } = state;
  const { orders } = state;
  const [fleetOptions, setFleetOptions] = useState([]);
  const [destination, setDestination] = useState(null);
  const firstRun = useRef(true);
  const isMobile = useMediaQuery('(max-width:1350px)');
  const limit = useMainStore((state) => state.limit);
  const [params, setParams] = useSearchParams();
  // const { state: mainState } = useContext(mainStore);
  // const { itemsCountPerPage } = mainState.Props;
  const columns = [
    {
      field: 'loadDate',
      headerName: 'بارگیری',
      width: 100,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'origin',
      headerName: 'بارگیری',
      width: 100,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetOptions',
      headerName: 'ناوگان',
      flex: 1,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetCount',
      headerName: 'تعداد',
      width: 100,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadTime',
      headerName: 'زمان',
      flex: 1,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadType',
      headerName: 'محموله',
      width: 120,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'packaging',
      headerName: 'بسته‌بندی',
      width: 120,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'orderStatus',
      headerName: 'وضعیت',
      width: 100,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
  ];

  const history = useHistory();

  const fetchOrders = async ({ page }) => {
    setLoading(true);
    const res = await fetchingOrders(
      id,
      page,
      limit,
      fleetOptions,
      destination
    );
    setLoading(false);
    dispatch({ type: 'LOAD', payload: { name: 'orders', value: res } });
  };

  const handlePageChange = async (page) => {
    console.log({ page });
    setParams([{ name: 'ordersPage', value: page }]);
  };

  const handleChangeFleetOptions = (selection) => {
    setFleetOptions(selection);
  };

  const handleChangeDestination = (city) => {
    setDestination(city);
  };

  const handleSelectOrder = (order) => {
    history.push(`/protected/admin/orders/${order?.row?.id}`);
  };

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    fetchOrders({ page: params.get('ordersPage') });
  }, [fleetOptions, destination, params.get('ordersPage'), limit]);

  return (
    <>
      <h4>سفارشات:</h4>
      <Accordion title="فیلترهای سفارش">
        <div className={classes.filters}>
          <FleetsTextFields
            selection={fleetOptions}
            onChange={handleChangeFleetOptions}
            single
          />
          <SelectCities
            isMulti={false}
            placeholder="مقصد"
            city={destination}
            onSelect={handleChangeDestination}
            hasLabel
          />
        </div>
      </Accordion>
      <div
        style={{
          width: '100%',
          marginTop: 10,
          height: isMobile ? 400 : 300,
          marginBottom: isMobile ? 100 : 0,
          overflowY: isMobile ? 'auto' : 'unset',
        }}
      >
        {orders ? (
          <DataGrid
            rows={
              orders && orders.docs
                ? orders.docs.map((o) => ({
                    id: o._id,
                    loadDate: moment(o.loadDate).format('jYY/jMM/jDD'),
                    origin: o.origin.title,
                    fleetOptions: o.fleetOptions
                      .map((fl) => {
                        return `${fl?.fleet?.title}(${fl?.title})`;
                      })
                      .join('، '),
                    fleetCount: o.fleetCount,
                    destination: o.destination.title,
                    loadTime: __(o.loadTime),
                    loadType: o?.cargos?.[0]?.type?.title,
                    packaging: o?.cargos?.[0]?.packaging?.title || '',
                    orderStatus: __(o.status),
                  }))
                : []
            }
            columns={columns}
            // pageSize={orders && orders.limit ? orders.limit : 0}
            rowCount={orders && orders.totalDocs ? orders.totalDocs : 0}
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={loading}
            disableMultipleSelection
            density="compact"
            onCellClick={handleSelectOrder}
            localeText={localText}
            pageSize={Number(limit)}
            disableSelectionOnClick
            components={{
              NoRowsOverlay: NoOrders,
            }}
            pageNumber={
              params.get('ordersPage') ? Number(params.get('ordersPage')) : 1
            }
            // checkboxSelection={true}
            // hasSelectAll
            footerPagination={true}
            totalPages={orders?.totalPages}
            defaultPage={params.get('page') * 1 || 1}
          />
        ) : (
          <Skeleton height={300} variant="rect" animation="wave" />
        )}
      </div>
    </>
  );
};

export default React.memo(OrdersList);
